module.exports = __webpack_public_path__ + "static/img/rank_224.f772d94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_224.png
// module id = 29gH
// module chunks = 0